import type { CodeExpr } from "@kex-resources/api-errors";

import { useEffect } from "react";

import { useHookOption } from "@features/errors/hooks/use-hook-option";
import {
  $availableApiErrors,
  removeApiError,
} from "@features/errors/model/api-errors.ts";
import { useFormatApiErrorMessage } from "@features/errors/use-api-error-message.ts";
import { useUnit } from "effector-react/effector-react.umd";
import { useIntl } from "react-intl";

import { useToaster } from "@shared/ui/chakra/feedback/toast";

export const useGroupErrorToast = (errorGroups: readonly CodeExpr[]) => {
  const errorGroupsOption = useHookOption(errorGroups);
  const errors = useUnit($availableApiErrors);
  const toaster = useToaster();
  const { formatApiErrorMessage } = useFormatApiErrorMessage();
  const { formatMessage } = useIntl();

  useEffect(() => {
    const currentErrorGroup = errorGroupsOption.current;
    for (const error of errors) {
      if (currentErrorGroup.includes(error.group)) {
        toaster.error({
          description: formatApiErrorMessage(error.code, error.payload),
          title: formatMessage({
            id: "toaster.globalError.title",
            defaultMessage: "Ошибка!",
          }),
        });
        removeApiError(error);
      }
    }
  }, [
    errors,
    formatApiErrorMessage,
    toaster,
    errorGroupsOption,
    formatMessage,
  ]);
};
